import React, { useState } from 'react';
import { Card, Heading, Header, CardBody, CardFooter, Text, Button } from 'grommet';
import { useTranslation } from 'react-i18next';

const ReadMoreReadLess = ({ title, text, maxLength = 350, summaryheight }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  // Ensure slicing only if text exceeds maxLength
  const displayText = isExpanded || text.length <= maxLength ? text : text.slice(0, maxLength);
  const { t } = useTranslation();

  return (
    <Card
      height={summaryheight}
      width="medium"
      round="small"
      background="light-1"
      elevation="medium"
      overflow-y="hidden"
    >
      <Header pad="small" style={{ paddingBottom: '0' }}>
        <Heading weight="bold" level={3} margin="none">
          {title}
        </Heading>
      </Header>  

      <CardBody
        pad={{ horizontal: 'small', vertical: 'small' }}
        style={{
          maxHeight: isExpanded ? 'none' : '450px',  // Adjust the height as needed
          overflowY: isExpanded ? 'auto' : 'hidden'
        }}
      >
        <Text size="medium">
          {displayText}
          {/* Add ellipsis only if the text is truncated */}
          {!isExpanded && text.length > maxLength && '...'}
        </Text>
      </CardBody>

      <CardFooter pad={{ horizontal: 'small', vertical: 'small' }} background="light-2">
        <Button label={isExpanded ?  t('Readless') : t('Readmore')} onClick={toggleExpand} />
      </CardFooter>
    </Card>
  );
};

export default ReadMoreReadLess;
